module.exports = __webpack_public_path__ + "static/img/payment-debit.70f95bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-debit.png
// module id = 7FqE
// module chunks = 0